module.exports = __webpack_public_path__ + "img/Octopus.8a219228.png";